import { HTMLAttributes, useCallback } from 'react';
import { Icon } from '~/components/atomic';
import { IconProps } from '~/components/atomic/Icon/Icon';
import InputLabelTitle from '../Input/InputLabelTitle/InputLabelTitle';
import * as S from './textarea.styled';

export interface TextareaProps extends HTMLAttributes<HTMLTextAreaElement> {
  id: string;
  label?: string;
  text: string;
  setText: (text: string) => void;
  placeholder: string;
  textLengthOpt?: boolean;
  maxText?: number;
  rows: 3;
  height?: number;
}

export default function Textarea({
  id,
  label,
  placeholder,
  text,
  setText,
  textLengthOpt,
  maxText = 30,
  rows = 3,
  height,
  ...props
}: TextareaProps) {
  const handleTextChange = useCallback(
    (setText: (text: string) => void) => {
      return (e: React.ChangeEvent) => {
        const inputText = (e.target as HTMLInputElement).value;
        if (maxText !== undefined && inputText.length > maxText) {
          setText(inputText.substring(0, maxText));
        } else {
          setText(inputText);
        }
      };
    },
    [maxText],
  );

  return (
    <S.Container>
      {label && <InputLabelTitle title={label} id={id} />}
      <S.TextareaBox height={height}>
        <textarea
          id={id}
          placeholder={placeholder}
          value={text}
          onChange={handleTextChange(setText)}
          rows={rows}
          {...props}
        />
      </S.TextareaBox>
      {textLengthOpt && (
        <S.TextValueBox>
          <S.TextValue>
            {text.length} / {maxText}
          </S.TextValue>
        </S.TextValueBox>
      )}
    </S.Container>
  );
}
